import {
  SET_JOB_LIST_SELECTED_VIEW,
  SET_JOB_SEARCH,
  SET_JOB_SEARCH_KEY,
  SET_JOB_SORTING_DIRECTION,
  SET_JOB_SORTING_FIELD,
} from '../../action/Build';

const initialState = {
  views: [],
  error: '',
  search: '',
  selectedView: { filters: [], operator: 'And' },
  sortingOption: { id: 'updatedAt' },
  direction: false,
};
const BuildListFilterReducer = (curState = initialState, action = { type: '', payload: '' }) => {
  let newState;
  switch (action.type) {
   case SET_JOB_SORTING_FIELD:
      newState = {
        ...curState,
        sortingOption: action.payload.sortingOption,
      };
      break;
    case SET_JOB_SORTING_DIRECTION:
      newState = {
        ...curState,
        direction: action.payload.direction,
      };
      break;
    case SET_JOB_LIST_SELECTED_VIEW:
      newState = {
        ...curState,
        selectedView: action.payload.selectedView,
      };
      break;
    case SET_JOB_SEARCH:
      newState = {
        ...curState,
        search: action.payload,
      };
      break;
    case SET_JOB_SEARCH_KEY:
      newState = {
        ...curState,
        searchKey: action.payload,
      };
      break;
    default:
      newState = curState;
  }

  return newState;
};

export default BuildListFilterReducer;
